import AbstractProvidedClass from "../shared/AbstractProvidedClass";
import ElementRow from "../sidebar/ElementRow";

export default class ElementCollection extends AbstractProvidedClass {
    collection = [];

    init(collection = []) {
        collection.map((el) => this.add(this.elementFactory.make(el), true));
    }

    display() {
        this.collection.map((el) => el.display());
    }

    add(el, index) {
        if (index !== undefined) {
            this.collection.splice(index, 0, el);
        } else {
            this.collection.push(el);
        }
        if (el.speciesIds.length > 0) {
            el.speciesIds.forEach((speciesId) => {
                this.speciesCollection.addObject(speciesId, el);
            });
        }
        this.getTab('elements').push(new ElementRow(this.provider, el));
    }

    delete(deleteElements) {
        deleteElements.map((shape) => {
            shape.row.delete();
            shape.speciesIds.map((speciesId) => {
                this.speciesCollection.removeObject(speciesId, shape);
            });
        });
        let deleteSet = new Set(deleteElements);
        this.collection = this.collection.filter((el) => !deleteSet.has(el));
    }

    bringToFront(element) {
        let index = this.collection.indexOf(element);
        this.collection.splice(index, 1);
        this.collection.push(element);
    }

    sendToBack(element) {
        let index = this.collection.indexOf(element);
        this.collection.splice(index, 1);
        this.collection.unshift(element);
    }

    bringForward(element) {
        let index = this.collection.indexOf(element);
        this.collection.splice(index, 1);
        this.collection.splice(index + 1, 0, element);
    }

    sendBackward(element) {
        let index = this.collection.indexOf(element);
        if (index == 0) {
            return;
        }
        this.collection.splice(index, 1);
        this.collection.splice(index - 1, 0, element);
    }

    move(oldIndex, newIndex) {
        let element = this.collection.splice(oldIndex, 1)[0];
        this.collection.splice(newIndex, 0, element);
    }

    indexOf(element) {
        return this.collection.indexOf(element);
    }

    mouseOver() {
        return this.collection.findLast((el) => el.mouseOver());
    }

    hovered() {
        return this.collection.findLast((el) => el.hovered());
    }

    hoveredAll() {
        return this.collection.filter(el => el.hovered());
    }

    surrounded(c1, c2) {
        var minX = Math.min(c1.absX, c2.absX);
        var maxX = Math.max(c1.absX, c2.absX);
        var minY = Math.min(c1.absY, c2.absY);
        var maxY = Math.max(c1.absY, c2.absY);
        return this.collection.filter((el) => el.surrounded(minX, minY, maxX, maxY));
    }

    export() {
        let exp = this.collection.map((el) => el.export());
        return exp;
    }

    store() {
        this.storage.save();
    }

    get length() {
        return this.collection.length;
    }
}
